var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 32,
    viewBox: "0 0 56 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7496 7.6123H23.4902V24.3846H32.7496V7.6123Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0799 15.9987C24.0784 14.3834 24.4416 12.789 25.1418 11.336C25.8421 9.88313 26.8611 8.60984 28.1217 7.61257C26.5606 6.37572 24.6858 5.60654 22.7115 5.39295C20.7372 5.17936 18.7432 5.52996 16.9572 6.40471C15.1713 7.27945 13.6655 8.64304 12.6121 10.3396C11.5586 12.0362 11 13.9972 11 15.9987C11 18.0002 11.5586 19.9613 12.6121 21.6578C13.6655 23.3544 15.1713 24.718 16.9572 25.5927C18.7432 26.4674 20.7372 26.818 22.7115 26.6045C24.6858 26.3909 26.5606 25.6217 28.1217 24.3848C26.8611 23.3876 25.8421 22.1143 25.1418 20.6614C24.4416 19.2084 24.0785 17.614 24.0799 15.9987Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2423 15.9987C45.2423 18.0001 44.6837 19.9612 43.6304 21.6578C42.577 23.3543 41.0713 24.7179 39.2854 25.5927C37.4995 26.4674 35.5054 26.818 33.5312 26.6044C31.5569 26.3909 29.6821 25.6217 28.1211 24.3848C29.3806 23.3866 30.3988 22.1131 31.0989 20.6604C31.7991 19.2077 32.1628 17.6137 32.1628 15.9987C32.1628 14.3837 31.7991 12.7897 31.0989 11.337C30.3988 9.88434 29.3806 8.61085 28.1211 7.61257C29.6821 6.37572 31.5569 5.60654 33.5312 5.39295C35.5054 5.17936 37.4995 5.52998 39.2854 6.40473C41.0713 7.27948 42.577 8.64307 43.6304 10.3396C44.6837 12.0362 45.2423 13.9973 45.2423 15.9987Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2379 22.6093V22.266H44.3752V22.196H44.0254V22.266H44.1628V22.6093H44.2379ZM44.917 22.6093V22.1953H44.8098L44.6865 22.4801L44.5631 22.1953H44.4558V22.6093H44.5315V22.297L44.6472 22.5663H44.7257L44.8414 22.2964V22.6093H44.917Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.4e83fd9c0e94f30f09ac0114137ce918.svg";
export { ForwardRef as ReactComponent };